import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView'
import NotFoundView from '@/views/NotFoundView'
import PostView from '@/views/PostView'

const routes = [
  {
    path: '/',
    name: 'routes-home',
    component: HomeView
  },
  {
    path: '/kit',
    name: 'routes-kit',
    component: () => import('../views/KitView'),
    children: [
      {
        path: ':index',
        component: () => import('../views/KitView')
      }
    ]
  },
  {
    path: '/post/:code/mobile',
    name: 'routes-post-mobile',
    params: { mobile: true },
    component: PostView
  },
  {
    path: '/post/:code-:hash',
    name: 'routes-post-hash',
    component: PostView
  },
  {
    path: '/post/:code',
    name: 'routes-post',
    component: PostView
  },
  {
    path: '/:pathMatch(.*)',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => {
    return {
      left: 0,
      top: 0
    }
  }
})

export default router
